import { useState } from "react"
import { SchoolSidebar } from "../components/ui/school/school-dashboard/school-sidebar"
import { AnalyticsStats } from "../components/ui/school/analytics/analytics-stats"
import { TermCountdown } from "../components/ui/school/analytics/term-countdown"
import { CareerPathChart } from "../components/ui/school/analytics/career-path-chart"
import { ClassProgressOverview } from "../components/ui/school/analytics/class-progress-overview"
import { StudyHoursChart } from "../components/ui/school/analytics/study-hours-chart"
import { AcademicCalendar } from "../components/ui/school/analytics/academic-calendar"
import { analyticsData, careerPathData, classProgressData, studyHoursData, calendarEvents } from "../lib/analytics-data"

const AnalyticsPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* School Sidebar */}
      <SchoolSidebar />

      {/* Main Content */}
      <main className="flex-1 lg:ml-64 overflow-y-auto">
        {/* Header */}
        <header className="sticky top-0 z-30 bg-transparent border-b border-transparent px-4 md:px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900 leading-tight">Analytics Dashboard</h1>
              <p className="text-sm text-gray-600 mt-1">Comprehensive insights and performance metrics</p>
            </div>
          </div>
        </header>

        {/* Content */}
        <div className="p-4 md:p-6 lg:p-8 space-y-8">
          {/* Grid Layout */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            {/* Stats Grid */}
            <div className="lg:col-span-8">
              <AnalyticsStats
                totalStudents={analyticsData.totalStudents}
                avgScore={analyticsData.avgScore}
                taskCompletion={analyticsData.taskCompletion}
                engagement={analyticsData.engagement}
              />
            </div>

            {/* Term Countdown */}
            <div className="lg:col-span-4">
              <TermCountdown
                daysLeft={analyticsData.daysLeft}
                hoursLeft={analyticsData.hoursLeft}
                termProgress={analyticsData.termProgress}
              />
            </div>
          </div>

          {/* Career Path & Class Progress */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            <div className="lg:col-span-7">
              <CareerPathChart data={careerPathData} />
            </div>
            <div className="lg:col-span-5">
              <ClassProgressOverview data={classProgressData} />
            </div>
          </div>

          {/* Study Hours Chart */}
          {/* <StudyHoursChart data={studyHoursData} /> */}

          {/* Academic Calendar - Commented as per original */}
          {/* <AcademicCalendar events={calendarEvents} /> */}
        </div>
      </main>
    </div>
  )
}

export default AnalyticsPage